// Shared helper: saves a worksheet submission to the server ledger.
// The server stores it in Firestore `worksheetz_submissions` (works for
// anonymous public visitors — no auth required) and mirrors job briefings,
// risk assessments, and tree surveys into the legacy staff collections.

export interface SaveResult {
  ok: boolean;
  id?: string;
  error?: string;
}

export const WORKSHEET_FORM_IDS = [
  'job-briefing', 'risk', 'health', 'media', 'work-order',
  'consultation', 'survey', 'storm', 'safety', 'equipment',
] as const;

export type WorksheetFormId = typeof WORKSHEET_FORM_IDS[number];

export async function saveWorksheet(formId: WorksheetFormId, data: Record<string, unknown>): Promise<SaveResult> {
  try {
    const apiBase = (import.meta as any).env?.VITE_API_BASE || '';
    const res = await fetch(`${apiBase}/api/worksheetz/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ formId, data }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      return { ok: false, error: err.error || `HTTP ${res.status}` };
    }
    const out = await res.json();
    return { ok: true, id: out.id };
  } catch (e: any) {
    return { ok: false, error: e?.message || 'Network error' };
  }
}
